<div class="close-btn" (click)="onConfirmClick()">
    <img src="../../../../assets/images/smallclose.svg" />
</div>
<mat-dialog-content>
    <div class="document-icon-container"><img mat-card-image class="document-icon"
            src="../../../../assets/images/document-icon.svg" alt="Photo"></div>
    <div class="bil-font-regular document-label">
        Articles of association are a document that specifies the regulations for a company's operations and defines the
        company's purpose.
    </div>
</mat-dialog-content>